import { styled } from 'goober';
import { useState, useEffect } from 'preact/hooks';
import Button from 'preact-material-components/Button';
import 'preact-material-components/Button/style.css';
import { useRequest } from '../../../api/services/useRequest';
import {
  useSalesDispatchContext,
  useSalesContext,
} from '../../../storeProviders/salesAppStore';
import { salesCheckEligibility } from '../../../api/controllers/salesController';
import { salesLendersListsRoute } from '../../../alias/salesAppRoutes';
import { route } from 'preact-router';
import Skeleton from '../Skeleton';
import { mobileVerificationOverLayHeight } from '../../salesApp/constants';
import errorIcon from '../../../assets/salesApp/error-icon.svg';
import successTick from '../../../assets/salesApp/success-tick.gif';
import saRoute from '../../salesApp/constants/saRoute';
import { useSalesAppTracker } from '../tracker';

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.2px;
  color: #455a64;
  padding: 60px 10px 35px 10px;
  .checkIcon {
    font-size: 45px;
    padding: 20px 0px;
  }
  .preApprovalTxt {
    padding: 15px 40px;
  }
  .preApprovalHeader {
    font-weight: 600;
    font-size: 24px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.2px;
    color: #9e170e;
  }
  .showEMIPlans {
    padding: 12px 35px;
  }
  .icon {
    width: 60px;
    height: 60px;
  }
`;
const BtnContainer = styled('div')`
  margin: 45px 0px 0px;
  display: flex;
  justify-content: center;
  .btnSection {
    width: 318px;
    height: 50px;
    margin: 0 auto;
    background-color: var(--primaryCTAColor);
    border-radius: 8px;
    border-color: transparent;
    font-weight: 600;
    font-size: 18px;
    letter-spacing: 0.1px;
    color: #ffffff;
    text-transform: capitalize;
  }
`;
const ShowInterstitialMsg = () => {
  const pageKey = 'sa_pv_check_eligibility_success';
  const salesDispatch = useSalesDispatchContext();
  const salesStore = useSalesContext();
  const salesAppTracker = useSalesAppTracker(pageKey);
  const [presentDataItem, setPresentDataItem] = useState();
  const [data, setData] = useState();
  const checkEligibilityRequest = useRequest();
  const {
    mobile,
    amount,
    selectedLenderDetails: selectedLenderFromStore,
    routeDetails,
    singleFunctionality,
  } = salesStore;
  const { path } = routeDetails || {};
  const [selectedLenderDetails, setSelectedLenderDetails] = useState(
    selectedLenderFromStore || [],
  );
  useEffect(() => {
    checkEligibilityApi();
  }, []);
  useEffect(() => {
    if (checkEligibilityRequest.value) {
      salesAppTracker.trackPageView('sa_pv_check_eligibility_success');
    }
  }, [checkEligibilityRequest.value]);

  useEffect(() => {
    setData(dataItems[presentDataItem]);
  }, [presentDataItem]);

  const checkEligibilityApi = () => {
    if (amount && mobile) {
      salesCheckEligibility(checkEligibilityRequest.makeRequest, {
        mobile,
        amount,
      }).then((res) => {
        if (res.success) {
          salesDispatch({
            type: 'STORE_STATE',
            payload: {
              checkEligibilityResponse: res.value,
              prevMobile: mobile,
            },
          });
          const { emiLenders, ntbLenders, isNtbAllowed, isPreApproved } =
            res.value || {};
          const lendersList = isPreApproved
            ? emiLenders
            : isNtbAllowed
            ? ntbLenders
            : [];
          if (lendersList && lendersList.length > 0) {
            let item = lendersList.filter((lender) => {
              const { lenderId } = lender || {};
              return lenderId === selectedLenderDetails.lenderId;
            });
            if (item && item.length === 1) {
              if (res.value.isPreApproved) {
                salesAppTracker.trackPageView('sa_pv_emicalc_emi_plan_ce_pa');
                setPresentDataItem('CUST_PRE_APPROVED_MSG');
              } else if (res.value.isNtbAllowed) {
                salesAppTracker.trackPageView('sa_pv_emicalc_emi_plan_ce_ntb');
                setPresentDataItem('CUST_CREDIT_LIMIT_MSG');
              }
            } else {
              salesAppTracker.trackPageView('sa_pv_emicalc_emi_plan_ce_ne');
              setPresentDataItem('TRY_ANOTHER_LENDER_MSG');
              path === '/sales-lender-details' && window.history.back();
            }
          } else {
            salesAppTracker.trackPageView(
              'sa_pv_emicalc_emi_plan_ce_no_lenders',
            );
            setPresentDataItem('NO_LENDERS_MSG');
          }
        }
      });
    }
  };

  const dataItems = {
    CUST_PRE_APPROVED_MSG: {
      iconType: successTick,
      showHeader: false,
      header: '',
      message: `Customer is pre-approved for Cardless EMI from ${
        selectedLenderDetails.name
      }`,
      helpText: `Showing personalised EMI plans from ${
        selectedLenderDetails.name
      } and a quick guide on completing payments`,
      btnText: 'OK',
      btnHandler: () => {},
    },
    CUST_CREDIT_LIMIT_MSG: {
      iconType: successTick,
      showHeader: false,
      header: '',
      message: `Customer is eligible to apply for a new credit line for Cardless EMI from ${
        selectedLenderDetails.name
      }`,
      helpText: `Showing personalised EMI plans from ${
        selectedLenderDetails.name
      } and a quick guide on applying for a new credit line`,
      btnText: 'OK',
      btnHandler: () => {},
    },
    NO_LENDERS_MSG: {
      iconType: errorIcon,
      showHeader: true,
      header: 'No Lenders Available',
      message:
        "No lender is available for Cardless EMI on the customer's mobile number entered here.",
      helpText:
        'Please try with a different mobile number or check again later.',
      btnText: 'Change Mobile Number',
      btnHandler: () => changeMobileNum(),
    },
    TRY_ANOTHER_LENDER_MSG: {
      iconType: errorIcon,
      showHeader: false,
      header: '',
      message: `${
        selectedLenderDetails.name
      } Cardless EMI is currently not available for this customer`,
      helpText:
        'Click the button below to see the available lenders for this mobile number',
      btnText: 'Show Available Lenders',
      btnHandler: () => showAvailableLenders(),
    },
    TRY_ANOTHER_NO_MSG: {
      iconType: errorIcon,
      showHeader: false,
      header: '',
      message: `${
        selectedLenderDetails.name
      } Cardless EMI is currently not available for this customer`,
      helpText: 'Please try with another mobile number or check again later',
      btnText: 'OK',
      btnHandler: () => anotherNumber(),
    },
  };

  const okBtnHandler = () => {
    salesDispatch({
      type: 'STORE_STATE',
      payload: {
        bottomSheetConfig: {
          showOverlay: false,
        },
      },
    });
  };

  const showAvailableLenders = () => {
    path === '/sales-lender-details'
      ? window.history.back()
      : saRoute(salesLendersListsRoute.path, singleFunctionality);
  };

  const anotherNumber = () => {
    path === '/sales-lender-details'
      ? window.history.back()
      : saRoute(salesLendersListsRoute.path, singleFunctionality);
    salesDispatch({
      type: 'STORE_STATE',
      payload: {
        mobile: '',
      },
    });
  };

  const changeMobileNum = () => {
    salesDispatch({
      type: 'STORE_STATE',
      payload: {
        bottomSheetConfig: {
          showOverlay: true,
          moduleName: 'MOBILE_VERIFICATION',
          overlayHeight: mobileVerificationOverLayHeight,
        },
      },
    });
  };

  return (
    <Container>
      <div>
        {data ? (
          <img src={data.iconType} alt='icon' className='icon' />
        ) : (
          <Skeleton
            style={{ height: '60px', width: '60px', margin: '0px auto 24px' }}
          />
        )}
      </div>
      {data ? (
        <div className='preApprovalHeader'>
          {data.showHeader && data.header}
        </div>
      ) : (
        <Skeleton
          style={{
            height: '24px',
            width: '100%',
            maxWidth: '250px',
            margin: '0px auto 16px',
          }}
        />
      )}
      {data ? (
        <div className='preApprovalTxt'>{data.message}</div>
      ) : (
        <Skeleton style={{ height: '48px', marginBottom: '16px' }} />
      )}

      {data ? (
        <div className='showEMIPlans'>{data && data.helpText}</div>
      ) : (
        <Skeleton style={{ height: '48px', marginBottom: '16px' }} />
      )}
      {data ? (
        <BtnContainer>
          <Button
            className='btnSection'
            onClick={() => {
              okBtnHandler();
              data.btnHandler();
            }}>
            {data && data.btnText}
          </Button>
        </BtnContainer>
      ) : (
        <Skeleton
          style={{
            height: '50px',
            width: '100%',
            maxWidth: '318px',
            margin: '0px auto 40px',
          }}
        />
      )}
    </Container>
  );
};

export default ShowInterstitialMsg;



// WEBPACK FOOTER //
// ./components/salesApp/common/ShowInterstitialMsg.js